import { render, staticRenderFns } from "./MasterApproval.vue?vue&type=template&id=ecb13f42&scoped=true&lang=pug&"
import script from "./scripts/MasterApproval.js?vue&type=script&lang=js&"
export * from "./scripts/MasterApproval.js?vue&type=script&lang=js&"
import style0 from "./MasterApproval.vue?vue&type=style&index=0&id=ecb13f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb13f42",
  null
  
)

export default component.exports